import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { socketOn } from 'lib/clients/socket';

import { showAlert } from 'components/shared/Alert/Alert';
import state from 'components/state';

const useAppointmentRescheduled = ({ propsAppointment, handleClose }) => {
  const currentUser = useRecoilValue(state.userState);
  const navigate = useNavigate();

  useEffect(() => {
    socketOn('appointment-rescheduled', (data) => {
      if (data.user.id === currentUser?.user_id || data.appointment_id !== propsAppointment.id)
        return;

      showAlert({
        title: 'This Appointment was Rescheduled',
        message: `This appointment rescheduled by ${data.user?.fullName}, no changes can be made!`,
        color: 'warning',
        buttons: [
          {
            text: 'View Rescheduled Appointment',
            onClick: () => {
              handleClose();
              setTimeout(
                () => navigate(`/portal/appointments?appointment_id=${data.newAppointmentId}`),
                1000
              );
            },
            color: 'warning'
          }
        ]
      });
    });
  }, []);

  return;
};

export default useAppointmentRescheduled;
